<!--LOADING-->
<ng-template [ngIf]="isLoading">
  <app-loading-page class="white-top-theme"></app-loading-page>
</ng-template>
<!--END LOADING-->
<!--TRAINING SUPPORT ELEARNING STATIC PAGE-->
<ng-template [ngIf]="!isLoading">
  <ng-container *ngIf="trainingSupportHeading && trainingSupportElearningPage">
    <section class="training-support-elearning">
      <div class="wrapper">
        <!--TRAINING SUPPORT ELEARNING CONTENT-->
        <div class="columns">
          <!--LEFT SIDE CONTENT-->
          <div class="left-aside-column">
            <!--SHARED CMS STATIC PAGE-->
            <app-static-page
              [title]="trainingSupportHeading.title"
              [bodyContent]="trainingSupportHeading.content">
            </app-static-page>
            <!--END SHARED CMS STATIC PAGE-->

            <!--ELEARNING STATIC PAGE CONTENT-->
            <app-elearning-static
              [elearningStaticPage]="trainingSupportElearningPage"
              [currentSlugPage]="slugName">
            </app-elearning-static>
            <!--END ELEARNING STATIC PAGE CONTENT-->
          </div>
          <!--END LEFT SIDE CONTENT-->

          <!--RIGHT SIDE CONTENT-->
          <ng-container *ngIf="parentNavItems && parentNavItems.length > 0">
            <div class="right-aside-column">
              <app-aside-list-navigation
                [navItems]="parentNavItems"
                [childNavItems]="childNavItems"
                [slugname]="'training-support'">
              </app-aside-list-navigation>
            </div>
          </ng-container>
          <!--END RIGHT SIDE CONTENT-->
        </div>
        <!--END TRAINING SUPPORT ELEARNING CONTENT-->
      </div>
    </section>
  </ng-container>
</ng-template>
<!--END TRAINING SUPPORT ELEARNING STATIC PAGE-->
